module.exports = __webpack_public_path__ + "static/media/ecc.2e18f260.png";